import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TitleStrategy } from '@angular/router';
import {
  API_BASE_URL,
  AppConfigService,
  CoreModule,
  MDS_API_CONFIG_URL,
  MDS_APP_CONFIG,
  MDS_CONFIG_SERVICE,
  MDS_SUPPORTED_CULTURES,
  MDS_TELEMETRY_INITIALIZERS,
  MDS_TRANSLATE_LOADERS,
  MDS_TRANSLATE_PROVIDER,
} from '@mds/angular-core';
import { LayoutModule, MDS_NAVIGATION_ITEMS } from '@mds/angular-layout-primeng';
import { AuthenticationModule } from '@mds/authentication';
import { TranslateModule } from '@ngx-translate/core';
import { RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { SharedModule } from 'primeng/api';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import {
  ConfigurationModel,
  ReAuthenticationInterceptor,
  TranslatedTitleStrategy,
  WebpackTranslateLoader,
  filterTelemetry,
  getApiBaseUrl,
  getApiConfigUrl,
  getRecaptchaSettings,
  navigationGroupsFactory,
  supportedCultures,
} from './shared';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    CoreModule,
    LayoutModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: MDS_TRANSLATE_PROVIDER,
    }),
    SharedModule,
    AuthenticationModule.forRoot<ConfigurationModel>((x) => {
      return {
        ...x.authConfig,
        myAccountUrl: undefined,
        acrValues: undefined,
        reAuthenticationMaxAgeInSeconds: x.reAuthentication.maxAgeInSeconds,
      };
    }),
  ],
  providers: [
    { provide: MDS_SUPPORTED_CULTURES, useValue: supportedCultures },
    { provide: MDS_API_CONFIG_URL, useFactory: getApiConfigUrl },
    { provide: MDS_CONFIG_SERVICE, useClass: AppConfigService },
    { provide: API_BASE_URL, useFactory: getApiBaseUrl },
    { provide: MDS_TRANSLATE_LOADERS, useClass: WebpackTranslateLoader, multi: true },
    { provide: MDS_NAVIGATION_ITEMS, useFactory: navigationGroupsFactory, deps: [MDS_APP_CONFIG] },
    { provide: HTTP_INTERCEPTORS, useClass: ReAuthenticationInterceptor, multi: true },
    { provide: RECAPTCHA_SETTINGS, useFactory: getRecaptchaSettings, deps: [MDS_APP_CONFIG] },
    {
      provide: MDS_TELEMETRY_INITIALIZERS,
      useValue: filterTelemetry,
      multi: true,
    },
    {
      provide: TitleStrategy,
      useClass: TranslatedTitleStrategy,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
